function getDecimal(n) {
    const _n = (n + "").split(".")[1];
    return parseInt((_n + "").slice(0, 2));
}

//
// Return the string for the time it takes to travel _distance_ at _speed_
//
// Number (km) -> Number (km/h) -> String
//
export function generateTimeString(distance, speed) {
    // decimal hours
    const hours = distance / speed;

    if (hours === 0) {
        return "";
    }

    if (hours < 1) {
        const minutes = Math.round(hours * 60);
        if (minutes === 0) {
            return "";
        }
        return `${minutes} ${minutes > 1 ? "minutes" : "minute"}`;
    }

    if (hours >= 24) {
        const days = Math.floor(hours / 24);
        return `${days} ${days > 1 ? "days" : "day"}`;
    }

    const minutes = Math.floor((getDecimal(hours) * 60) / 100);
    const minutesStr = minutes > 0 ? `${minutes}m` : "";
    const _hours = Math.floor(hours);
    const hoursStr = _hours > 0 ? `${_hours}h` : "";
    return `${hoursStr}${minutesStr}`;
}

//
// Return the _routes_ that matches the _selectedFilters_ criteria.
//
// Object (application state) -> Array
//
export function filterRoutes({ selectedFilters, routes }) {
    return !selectedFilters.length
        ? routes
        : routes.filter(
              route =>
                  route.itineraries.filter(itinerary => selectedFilters.includes(itinerary.route_type.id)).length ===
                  selectedFilters.length,
          );
}
